import script from "./Page__Front.vue?vue&type=script&setup=true&lang=js"
export * from "./Page__Front.vue?vue&type=script&setup=true&lang=js"

import "./Page__Front.vue?vue&type=style&index=0&id=28aefb48&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/wp-content/themes/stewartrealtor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28aefb48"]])

export default __exports__